export abstract class Symbols {

    public static UserActions = "UserActions";
    public static UserStore = "UserStore";
    public static AchievementsService = "AchievementsService";
    public static SystemEventService = "SystemEventService";
    public static HandHistoryService = "HandHistoryService";
    public static TournamentHistoryService = "TournamentHistoryService";
    public static RakeReportConfigService = "RakeReportConfigService";
    public static SitAndGoService = "SitAndGoService";
    public static BlindsStructureService = "BlindsStructureService";
    public static PayoutStructureService = "PayoutStructureService";
    public static TransactionEntriesService = "TransactionEntriesService";
    public static ProductService = "ProductService";
    public static BlackjackHandHistoryService = "BlackjackHandHistoryService"
    public static CaribbeanPokerHandHistoryService = "CaribbeanPokerHandHistoryService"
    public static CasinoHoldemHandHistoryService = "CasinoHoldemHandHistoryService"
    public static NotificationService = "NotificationService"
    public static SlotSpinHistoryService = "SlotSpinHistoryService"
    public static TransactionHistoryService = "TransactionHistoryService"
}



// WEBPACK FOOTER //
// ./src/app/ioc/Symbols.ts